<template>
	<v-container fluid pa-0 dark flat my-5>
		<v-layout row wrap class="inner-container" justify-center mx-5>
			<v-flex xs12 justify-center class="text-xs-center">
				<h1 class="text-duo">Algunos de nuestros clientes</h1>
				<v-divider></v-divider>
				<div class="mt-1" v-html="clientes.descripcion"></div>
			</v-flex>
		</v-layout>
		<v-layout row wrap class="inner-container" justify-center mx-5 mt-5>
			<v-flex 
	      v-for="(item,i) in clientes.logos_clientes"
	      :key="i"
	      xs6 sm3 lg2 justify-center>
          <div class="logos-container text-xs-center">
            <img :src="item" style="height:100px;max-width:200px;">
          </div>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
	import { EventBus } from '../../events.js'
	import * as firebase from 'firebase/app'
	import 'firebase/firestore'
  export default {
  	name: 'Clientes',
	title: 'Clientes',
    data () {
      return {
        clientes: {}
      }
    },
    methods:{
			get_mantenedores(){
				let db = firebase.firestore()
				let self = this
				db.collection("mantenedores").doc("clientes").get().then(function(doc) {
						if (doc.exists) {
								self.clientes = doc.data()
						} else {
								// doc.data() will be undefined in this case
								console.log("No such document!");
						}
				}).catch(function(error) {
						console.log("Error getting document:", error);
				});

			}
    },
    mounted(){
    	this.get_mantenedores()
    }
  }
</script>
<style type="text/css">
	.theme--light.v-divider {
	    border-color: #1f97b9 !important; 
	}
</style>